import { render, staticRenderFns } from "./zqzs.vue?vue&type=template&id=267ada76&scoped=true&"
import script from "./zqzs.vue?vue&type=script&lang=js&"
export * from "./zqzs.vue?vue&type=script&lang=js&"
import style0 from "./zqzs.vue?vue&type=style&index=0&id=267ada76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267ada76",
  null
  
)

export default component.exports